/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"

import Header from "./header"
import Footer from "./footer"
import Credits from "./credits"
import "../styles.css"

function Wrapper(props) {
  return(
    <div
      style={{
        margin: `0 auto`,
        padding: `0 1.0875rem 1.45rem`,
      }}
      className="bg-offwhite"
    >
      {props.children}    
    </div>
  )
}

function Layout(props) {
  return (
    <>
      <Header siteTitle={"Docent Toad" || `Title`} />
      <Wrapper>
        <main>{props.children}</main>
      </Wrapper>
      <Footer />
      <Credits />
    </>
  )
}


export default Layout
